import { Resource } from 'angular4-hal';

export class Stance extends Resource {
    index: string;
    name: string;
    description: string;
}
